import { ReactNode } from 'react';
import { AiFillDashboard } from 'react-icons/ai';
import { BiBuilding } from 'react-icons/bi';

export type SidebarItem = {
  label: string;
  icon?: ReactNode;
  href?: string;
  children?: SidebarItem[];
};

export const sidebarData: SidebarItem[] = [
  {
    label: 'Dashboard',
    icon: <AiFillDashboard size={18} />,
    href: '/admin'
  },
  {
    label: 'Company',
    icon: <BiBuilding size={18} />,
    children: [
      {
        label: 'Pending',
        href: '/admin/company/pending'
      },
      {
        label: 'Activated',
        href: '/admin/company/activated'
      }
    ]
  }
];
